export default __webpack_public_path__ + "static/media/pf.9bbfba4c.png";